import BuyInPreferencePopover from "./BuyInPreferencePopover";

export default function RegistrosToolbar({
  registros,
  filtered,
  activeFilters,
  completePreferences,
  setCompletePreferences,
  onRefreshCommonTournaments,
  registroForm,
  registroModal,
  setShowFilters,
}) {
  const countLabel =
    filtered.length !== registros.length
      ? `${filtered.length} de ${registros.length} registro${
          registros.length !== 1 ? "s" : ""
        }`
      : `${registros.length} registro${registros.length !== 1 ? "s" : ""}`;

  const toggleRegistroForm = () => {
    if (registroModal.isOpen && !registroModal.editingId) {
      registroModal.close();
      registroForm.reset();
      return;
    }
    setShowFilters(false);
    registroModal.open();
    registroForm.reset();
    onRefreshCommonTournaments?.();
  };

  return (
    <div className="registros-toolbar">
      <div className="registros-toolbar__summary-group">
        <span className="section-count-label">
          {countLabel}
        </span>
        <button
          className={`btn-ghost filter-toggle-button ${
            activeFilters ? "filter-toggle-button--active" : ""
          }`}
          onClick={() => setShowFilters((f) => !f)}
        >
          Filtros
          {activeFilters && <span className="filter-badge">ativos</span>}
        </button>
      </div>

      <div className="registros-toolbar__actions">
        <BuyInPreferencePopover
          preferences={completePreferences}
          onChange={setCompletePreferences}
        />
        <button className="btn-red registro-primary-action" onClick={toggleRegistroForm}>
          {registroModal.isOpen && !registroModal.editingId
            ? "Cancelar"
            : "+ Registrar Participação"}
        </button>
      </div>
    </div>
  );
}
